import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=e28e2400&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e28e2400')) {
      api.createRecord('e28e2400', component.options)
    } else {
      api.reload('e28e2400', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=e28e2400&", function () {
      api.rerender('e28e2400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G5TlFMCfq87t/JS/comp/FavElement.vue"
export default component.exports